import { graphql, useStaticQuery } from "gatsby"

export const useBanner = () => {
  const {
    siteConfig: { homepage_banner: banner },
  } = useStaticQuery(graphql`
    query MyQuery {
      siteConfig {
        homepage_banner {
          link
          logo {
            cdn
          }
          content {
            content
          }
          status
        }
      }
    }
  `)

  return { banner }
}
